import { serializable, alias, primitive, list, object } from 'serializr';
import { UserAccessRole } from './userRecord.model';

export class UserDetails {
  @serializable(alias('id', primitive()))
  id!: number;

  @serializable(alias('name', primitive()))
  name!: string;

  @serializable(alias('title', primitive()))
  title!: string;

  @serializable(alias('email', primitive()))
  email!: string;

  @serializable(alias('phone', primitive()))
  phone?: string;

  @serializable(object(UserAccessRole))
  role!: UserAccessRole;

  @serializable(list(object(UserAccessRole)))
  groups!: UserAccessRole[];

  @serializable(alias('accessExpiresAt', primitive()))
  accessExpiresAt!: string | null;

  @serializable(alias('accessDurationType', primitive()))
  accessDurationType?: string;

  @serializable(alias('clientOrgName', primitive()))
  clientOrgName?: string;

  @serializable(alias('subscriptionExpiresAt', primitive()))
  subscriptionExpiresAt?: string;
}
